import { createAsyncThunk } from "@reduxjs/toolkit";
import useAxios from "../../utils/useAxios";
import { URL_ORDERING_PRACTITIONERS } from "config/connString";

const getOrderingPractitioner = createAsyncThunk(
  "ordering-practitioners/get-ordering-practitioner",
  async (data) => {
    try {
      const api = useAxios();
      const config = {
        params: {
          id: data.id,
        },
      };
      const response = await api.get(
        URL_ORDERING_PRACTITIONERS + "/ordering-practitioners-lookup",
        config
      );
      return response.data;
    } catch (error) {
      return Promise.reject(error.response);
    }
  }
);

export { getOrderingPractitioner };
